import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar, {
  BAR_COLORS,
} from '@bitComponents/unifiedComponents/ProgressBar';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from '@gcloud-npm/components.text';
import usePrevious from './utils/usePrevious';
import { WAITING_PAGE_STEPS, ANIMATION_RENDER } from './constants';
import WaitingStep from './waitingStep/WaitingStep';
import BouncingLogo from './common/BouncingLogo';
import './WaitingPage.scss';
import FlyingParrot from './common/FlyingParrot/FlyingParrot';
import Football from './common/Football/Football';

export { WAITING_PAGE_STEPS, ANIMATION_RENDER };

export const WAITING_PAGE_ANIMATIONS = {
  BOUNCING_LOGO: "BOUNCING_LOGO",
  FLYING_PARROT: "FLYING_PARROT",
  FOOTBALL: "FOOTBALL",
}


export default function WaitingPage({ textToShow, animation }) {
  const prevTextToShow = usePrevious(textToShow);
  const isCheck = textToShow && prevTextToShow && textToShow !== prevTextToShow;

  return (
    <div className="waitingPageContainer">
      <div className="waitingPageContent waitingCenter">
        <div className="waitingSection">
          <TextInfo
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.GREY6}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            size={TEXT_SIZE.TITLE5}
            text={textToShow}
          />
        </div>
        <div className="waitingSection">
          <ProgressBar
            time={20}
            id={`WaitingPageProgressBar${textToShow}`}
            className="progressBarWrapper"
            loop
            barColor={BAR_COLORS.BLUE}
          />
        </div>
        {animation && (
          <div className="waitingSection waitingStepContainer">
            {animation === WAITING_PAGE_ANIMATIONS.FLYING_PARROT && (
              <FlyingParrot />
            )}
            {animation === WAITING_PAGE_ANIMATIONS.FOOTBALL && (
              <Football />
            )}
            {animation !== WAITING_PAGE_ANIMATIONS.FLYING_PARROT && animation !== WAITING_PAGE_ANIMATIONS.FOOTBALL && (
              <WaitingStep
                component={() => (
                  <BouncingLogo />
                )}
                isCheck={isCheck}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

WaitingPage.propTypes = {
  /**
   * {
   *  "info": "Valor que define la página de espera a mostrar",
   *  "kind": "both",
   *  "beautifulName": "Página a mostrar"
   * }
   */
  textToShow: PropTypes.string,
  /**
   * {
   *  "info": "Valor que define la animacion a mostrar",
   *  "kind": "both",
   *  "beautifulName": "Página a mostrar"
   * }
   */
  animation: PropTypes.oneOf(Object.values(WAITING_PAGE_ANIMATIONS)),
};

WaitingPage.defaultProps = {
  textToShow: 'Preparando tu pedido',
  animation: null,
};
